module.exports = __webpack_public_path__ + "img/check_circle-24px.6b3c366e.svg";